import React from 'react';
import styles from './Home.module.css';
import { Link } from 'react-router-dom';

import tiktokLogo from '../../assets/tiktok.png';

export default class Home extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
        };
    };

    componentDidMount() {
    };

    componentWillUnmount() {
    };
    
    iOS = () => {
        return [
            'iPad Simulator',
            'iPhone Simulator',
            'iPod Simulator',
            'iPad',
            'iPhone',
            'iPod'
        ].includes(navigator.platform)
        // iPad on iOS 13 detection
        || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
    };

    renderMainScreen = () => {

        return (
            <div className={styles.rootView}>
                <div className={styles.contentRootView}>
                    <div className={styles.content}>
                        <a href='/secret-tiktok'>
                            <div className={styles.tiktokButton}>
                                <div className={styles.tiktokInnerButton}>
                                    {/* <img className={styles.storeLogo} src={tiktokLogo} /> */}
                                    Secret TikTok
                                </div>
                            </div>
                        </a>

                        {/* <button
                            className={`${styles.button} ${styles.buttonF}`}
                            onClick={() => this.setState({ currentScreen: this.screens.Gender })}
                        >
                            Vibe Me Up!
                        </button> */}
                    </div>
                </div>

                {this.renderFooter()}
            </div>
        );
    };

    renderFooter = () => {
        return (
            <div className={styles.footer}>
                <div className={styles.footerContainer}>
                    <div className={styles.footerLinks}>
                        <a href='mailto:vibegameapp@gmail.com' className={styles.link}>Help</a>
                        <Link to="/terms" className={styles.link}>Terms</Link>
                        <Link to="/privacy" className={styles.link}>Privacy</Link>
                    </div>
                    <div className={styles.copyright}>© KVK LLC. 2025</div>
                </div>
            </div>
        );
    };

    render() {
        return this.renderMainScreen();
    };
};